export const NOT_STARTED = 'NOT_STARTED';
export const IN_PROGRESS = 'IN_PROGRESS';
export const COMPLETED = 'COMPLETED';
export const REJECTED = 'REJECTED';
export const SKIPPED = 'SKIPPED';
